exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n/*\n  SCSS for resume.component.ts\n */\n.pic-centered {\n  display: inline-block; }\n\n.muted_text {\n  color: #ffffff !important; }\n\n.name {\n  color: #ffffff;\n  font-size: 50px; }\n\n.title-color-base {\n  color: #000000;\n  padding: 10px; }\n  .title-color-base.title-yellow {\n    background-color: #DFD000; }\n  .title-color-base.title-red {\n    background-color: #8E0014; }\n  .title-color-base.title-blue {\n    background-color: #4e67a3; }\n  .title-color-base.title-green {\n    background-color: #69CA00; }\n\n.title-span {\n  font-size: 1.5em;\n  font-weight: 300;\n  margin-bottom: 10px;\n  display: inline-block; }\n\nh2 {\n  color: #ffffff; }\n\n:host {\n  display: block;\n  height: 100%;\n  color: #9d9d9d; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/resume/resume.component.scss
// module id = 390
// module chunks = 1